import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSupabase } from '../supabaseAuth';
import { Container, Row, Col, Button } from 'react-bootstrap';

const Logout = () => {
  const navigate = useNavigate();
  const { logout } = useSupabase();
  
  React.useEffect(() => {
    const performLogout = async () => {
      try {
        await logout();
        // Redirect to login page after successful logout
        navigate('/login', { 
          state: { message: 'You have been successfully logged out.' } 
        });
      } catch (error) {
        console.error('Logout error:', error);
      }
    };
    
    performLogout();
  }, [logout, navigate]);
  
  return (
    <Container fluid className="bg-light min-vh-100 d-flex align-items-center justify-content-center">
      <Row className="justify-content-center">
        <Col xs={12} sm={10} md={8} lg={6} xl={5} className="text-center">
          <div className="mb-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
          <h2 className="mb-3">Logging you out...</h2>
          <p className="text-muted mb-4">Please wait while we securely log you out of your account.</p>
          <Button 
            variant="outline-primary" 
            onClick={() => navigate('/login')}
          >
            Return to Login
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default Logout;
